import { render, staticRenderFns } from "./serviceEnquiryDashboard.vue?vue&type=template&id=9e20001a&scoped=true"
import script from "./serviceEnquiryDashboard.vue?vue&type=script&lang=js"
export * from "./serviceEnquiryDashboard.vue?vue&type=script&lang=js"
import style0 from "./serviceEnquiryDashboard.vue?vue&type=style&index=0&id=9e20001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e20001a",
  null
  
)

export default component.exports